export default "__VITE_ASSET__Bzq7MGVa__"